/**
 * @file Renders the layout footer with the organization's copyright
 * line.
 */
import type { CSSProperties } from "react";
import { Layout, Typography, theme } from "antd";

const { Text } = Typography;

const LABEL_RIGHTS_RESERVED = "All rights reserved.";

type Props = {
  style?: CSSProperties;
  organizationName?: string;
};

/**
 * Renders the organization's copyright line, or nothing when no
 * organization name is set.
 */
const Footer = ({
  style = {},
  organizationName = undefined,
}: Props): JSX.Element | null => {
  const { token } = theme.useToken();
  const { colorBgContainer } = token;

  const yearDate = new Date().getFullYear();

  if (!organizationName) {
    return null;
  }

  return (
    <Layout.Footer
      style={{
        textAlign: "center",
        backgroundColor: colorBgContainer,
        ...style,
      }}
    >
      <Text type="secondary">
        {`© ${yearDate} ${organizationName}`}

        <br />

        {LABEL_RIGHTS_RESERVED}
      </Text>
    </Layout.Footer>
  );
};

export default Footer;
